import {
  GET_BUSINESS_EMAIL_TEMPLATES,
  GET_BUSINESS_EMAIL_TEMPLATES_SUCCESS,
  GET_BUSINESS_EMAIL_TEMPLATES_FAIL,
  RESET_LIST_BUSINESS_EMAIL_TEMPLATES,
  GET_BUSINESS_EMAIL_TEMPLATE_DETAILS,
  GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_SUCCESS,
  GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_FAIL,
  CREATE_BUSINESS_EMAIL_TEMPLATE,
  CREATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  CREATE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  UPDATE_BUSINESS_EMAIL_TEMPLATE,
  UPDATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  DELETE_BUSINESS_EMAIL_TEMPLATE,
  DELETE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  DELETE_BUSINESS_EMAIL_TEMPLATE_FAIL
} from "./actionTypes";

export const getBusinessEmailTemplates = params => ({
  type: GET_BUSINESS_EMAIL_TEMPLATES,
  payload: { params },
});

export const getBusinessEmailTemplateSuccess = (items, params) => ({
  type: GET_BUSINESS_EMAIL_TEMPLATES_SUCCESS,
  payload: { items, params }
});

export const getBusinessEmailTemplateFail = error => ({
  type: GET_BUSINESS_EMAIL_TEMPLATES_FAIL,
  payload: { error },
});

export const resetListBusinessEmailTemplates = () => ({
  type: RESET_LIST_BUSINESS_EMAIL_TEMPLATES,
  payload: {},
});

export const getBusinessEmailTemplateDetails = emailTemplateId => ({
  type: GET_BUSINESS_EMAIL_TEMPLATE_DETAILS,
  payload: { emailTemplateId },
});

export const getBusinessEmailTemplateDetailsSuccess = (emailTemplate) => ({
  type: GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_SUCCESS,
  payload: { emailTemplate }
});

export const getBusinessEmailTemplateDetailsFail = error => ({
  type: GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_FAIL,
  payload: { error },
});

export const createBusinessEmailTemplate = emailTemplate => ({
  type: CREATE_BUSINESS_EMAIL_TEMPLATE,
  payload: { emailTemplate },
});

export const createBusinessEmailTemplateSuccess = (emailTemplate) => ({
  type: CREATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  payload: { emailTemplate }
});

export const createBusinessEmailTemplateFail = error => ({
  type: CREATE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  payload: { error },
});

export const updateBusinessEmailTemplate = (id, emailTemplate) => ({
  type: UPDATE_BUSINESS_EMAIL_TEMPLATE,
  payload: { id, emailTemplate },
});

export const updateBusinessEmailTemplateSuccess = (emailTemplate) => ({
  type: UPDATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  payload: { emailTemplate }
});

export const updateBusinessEmailTemplateFail = error => ({
  type: UPDATE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  payload: { error },
});

export const deleteBusinessEmailTemplate = emailTemplateId => ({
  type: DELETE_BUSINESS_EMAIL_TEMPLATE,
  payload: { emailTemplateId },
});

export const deleteBusinessEmailTemplateSuccess = (emailTemplateId) => ({
  type: DELETE_BUSINESS_EMAIL_TEMPLATE_SUCCESS,
  payload: { emailTemplateId }
});

export const deleteBusinessEmailTemplateFail = error => ({
  type: DELETE_BUSINESS_EMAIL_TEMPLATE_FAIL,
  payload: { error },
});
